export const shouldShowRegisteredAgentDetails = (agentTypeBasTaxBT) =>
  agentTypeBasTaxBT === "T" || agentTypeBasTaxBT === "B";

/** Australian FY end date for default project (e.g. 30/06/2026 for TR 2026). */
export const getDefaultFyProjectDate = () => {
  const now = new Date();
  const month = now.getMonth();
  const year = now.getFullYear();
  const fyEndYear = month >= 6 ? year + 1 : year;
  return `30/06/${fyEndYear}`;
};

export const buildSubscriberAgentPayload = (values) => {
  const showRegisteredAgentDetails = shouldShowRegisteredAgentDetails(
    values.agentTypeBasTaxBT
  );

  return {
    xxsAgentTypeBasTaxBT: values.agentTypeBasTaxBT || "",
    TaxAgentRAN: showRegisteredAgentDetails
      ? values.registeredAgentNumber
      : "",
    TaxAgentName: showRegisteredAgentDetails ? values.businessName : "",
    TaxAgentEmail: showRegisteredAgentDetails
      ? values.registeredAgentEmailAddress
      : "",
    TaxAgentPhone: showRegisteredAgentDetails
      ? values.registeredAgentPhoneNumber
      : "",
  };
};
